import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "tbdc-floatingmenu" }
const _hoisted_2 = { style: {"position":"absolute","margin-left":"6px","top":"-1px","font-size":"11px","font-weight":"normal","opacity":"0.6"} }
const _hoisted_3 = { style: {"position":"absolute","margin-left":"6px","font-size":"14px","font-weight":"normal","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis","width":"97%"} }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  style: {"position":"absolute","right":"0"},
  class: "tbdc-floatingmenubutton"
}
const _hoisted_9 = { class: "tbdc-floatingmenu" }
const _hoisted_10 = { class: "tbdc-floatingmenubutton" }
const _hoisted_11 = { class: "tbdc-scenariostatus" }
const _hoisted_12 = {
  key: 0,
  style: {"position":"absolute","font-size":"24px","right":"10px","top":"-1px","color":"orange","text-align":"right","padding-top":"2px","padding-left":"0px","border-radius":"50%"}
}
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "tbdc-floatingmenubutton" }
const _hoisted_18 = { style: {"display":"block","padding-top":"0"} }
const _hoisted_19 = { style: {"display":"block","padding-top":"0"} }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { style: {"display":"block","padding-top":"0"} }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = {
  key: 0,
  style: {"position":"absolute","right":"1em"}
}
const _hoisted_24 = { style: {"display":"block","padding-top":"0"} }
const _hoisted_25 = { class: "tbdc-floatingmenubutton" }
const _hoisted_26 = { class: "tbdc-floatingmenubutton" }
const _hoisted_27 = { class: "tbdc-floatingmenubutton" }
const _hoisted_28 = { class: "tbdc-floatingmenubutton" }
const _hoisted_29 = { class: "tbdc-floatingmenubutton" }
const _hoisted_30 = { class: "text-caption text--secondary mb-2" }
const _hoisted_31 = {
  class: "d-flex align-center",
  style: {"gap":"12px"}
}
const _hoisted_32 = {
  class: "tbdc-floatingmenubutton",
  style: {"position":"relative"}
}
const _hoisted_33 = { style: {"display":"flex","justify-content":"flex-start"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_action = _resolveComponent("v-list-item-action")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_ScenarioStatus = _resolveComponent("ScenarioStatus")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_virtual_scroll = _resolveComponent("v-virtual-scroll")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_label = _resolveComponent("v-label")!
  const _component_v_slider = _resolveComponent("v-slider")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_Agent = _resolveComponent("Agent")!

  return (_ctx.getModel && _ctx.getScenario)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.isAuthenticated && _ctx.scenario && _ctx.scenarios)
            ? (_openBlock(), _createBlock(_component_v_menu, {
                key: 0,
                "max-height": "none",
                "close-on-content-click": false,
                modelValue: _ctx.scenariosMenuVisible,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.scenariosMenuVisible) = $event)),
                "content-class": "tbdc-floatingmenucontent"
              }, {
                activator: _withCtx(({ props: menuProps }) => [
                  _createVNode(_component_v_tooltip, {
                    location: "bottom",
                    "open-delay": "250",
                    "open-on-hover": true
                  }, {
                    activator: _withCtx(({ props: tooltipProps }) => [
                      _createElementVNode("div", _mergeProps(_ctx.mergeProps(menuProps, tooltipProps), {
                        class: "tbdc-floatingmenubutton tbdc-dropdownmenu",
                        style: {"padding":"10px","padding-top":"13px","margin-left":"10px","margin-right":"48px","width":"calc(100% - 64px)"}
                      }), [
                        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("message.scenario")), 1),
                        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.getScenario.name), 1)
                      ], 16)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("message.scenarios")), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_subheader, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("message.filterScenarios")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_form, {
                        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_v_text_field, {
                                  class: "text-field-icon",
                                  density: "compact",
                                  variant: "outlined",
                                  modelValue: _ctx.standByFilterScenarios,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.standByFilterScenarios) = $event)),
                                  "append-icon": _ctx.getFilterScenarios!= null && _ctx.getFilterScenarios != '' ? 'mdi-exclamation' : '',
                                  "hide-details": "",
                                  "single-line": "",
                                  label: _ctx.$t('message.name'),
                                  "onClick:clear": _cache[1] || (_cache[1] = ($event: any) => (_ctx.findScenarios(null))),
                                  clearable: ""
                                }, null, 8, ["modelValue", "append-icon", "label"])
                              ]),
                              _createVNode(_component_v_list_item_action, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_btn, {
                                    type: "submit",
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.findScenarios(_ctx.standByFilterScenarios);}),
                                    icon: "",
                                    variant: "text"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                                          _createTextVNode("mdi-magnify", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_virtual_scroll, {
                        bench: "20",
                        height: Math.min(384,_ctx.scenariosLeveled.length * 48),
                        "item-height": "48",
                        items: _ctx.scenariosLeveled,
                        "min-width": Math.max(_ctx.maxLengthScenarioName?.length*8,400)
                      }, {
                        default: _withCtx(({ item }) => [
                          (item.scenario.changes && item.scenario.changes.length > 0 && item.scenario.parentScenarioId != null)
                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                key: 0,
                                "open-delay": "250",
                                "open-on-hover": true,
                                location: "bottom"
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_list_item, _mergeProps(props, {
                                    onClick: ($event: any) => (_ctx.setScenarioAndCloseMenu(item.scenario))
                                  }), {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_action, {
                                        style: _normalizeStyle({ marginLeft: (item.level) * 20 + 'px' })
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ScenarioStatus, {
                                            status: item.scenario.status,
                                            scenario: item.scenario,
                                            changes: item.scenario.changeCount
                                          }, null, 8, ["status", "scenario", "changes"])
                                        ]),
                                        _: 2
                                      }, 1032, ["style"]),
                                      _createElementVNode("div", {
                                        style: _normalizeStyle({ 'font-weight': item.scenario.isTop ? 'bold' : 'normal' })
                                      }, [
                                        _createVNode(_component_v_list_item_title, {
                                          style: _normalizeStyle({ marginLeft: (item.level) * 20 + 'px' })
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("  " + _toDisplayString(item.scenario.name), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["style"])
                                      ], 4)
                                    ]),
                                    _: 2
                                  }, 1040, ["onClick"])
                                ]),
                                default: _withCtx(() => [
                                  (item.scenario.changes && item.scenario.changes.length > 0 && item.scenario.parentScenarioId != null)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.scenario.changes, (change) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: change.locationId
                                          }, [
                                            (change.changeType == 1)
                                              ? (_openBlock(), _createElementBlock("img", {
                                                  key: 0,
                                                  src: require('../../assets/opening.png'),
                                                  class: "tbdc-changetypeimage"
                                                }, null, 8, _hoisted_5))
                                              : _createCommentVNode("", true),
                                            (change.changeType == 2)
                                              ? (_openBlock(), _createElementBlock("img", {
                                                  key: 1,
                                                  src: require('../../assets/closure.png'),
                                                  class: "tbdc-changetypeimage"
                                                }, null, 8, _hoisted_6))
                                              : _createCommentVNode("", true),
                                            (change.changeType == 3)
                                              ? (_openBlock(), _createElementBlock("img", {
                                                  key: 2,
                                                  src: require('../../assets/edit.png'),
                                                  class: "tbdc-changetypeimage"
                                                }, null, 8, _hoisted_7))
                                              : _createCommentVNode("", true),
                                            _createTextVNode(" " + _toDisplayString(change.locationName), 1)
                                          ]))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024))
                            : (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 1,
                                onClick: ($event: any) => (_ctx.setScenarioAndCloseMenu(item.scenario)),
                                onMouseenter: ($event: any) => (_ctx.fetchAndSetScenarioChanges(item.scenario))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_action, {
                                    style: _normalizeStyle({ marginLeft: (item.level) * 20 + 'px' })
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ScenarioStatus, {
                                        status: item.scenario.status,
                                        scenario: item.scenario,
                                        changes: item.scenario.changeCount
                                      }, null, 8, ["status", "scenario", "changes"])
                                    ]),
                                    _: 2
                                  }, 1032, ["style"]),
                                  _createElementVNode("div", {
                                    style: _normalizeStyle({ 'font-weight': item.scenario.isTop ? 'bold' : 'normal' })
                                  }, [
                                    _createVNode(_component_v_list_item_title, {
                                      style: _normalizeStyle({ marginLeft: (item.level) * 20 + 'px' })
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("  " + _toDisplayString(item.scenario.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["style"])
                                  ], 4)
                                ]),
                                _: 2
                              }, 1032, ["onClick", "onMouseenter"]))
                        ]),
                        _: 1
                      }, 8, ["height", "items", "min-width"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (_ctx.isAuthenticated && _ctx.scenario && _ctx.scenarios)
            ? (_openBlock(), _createBlock(_component_v_menu, {
                key: 1,
                "content-class": "tbdc-floatingmenucontent"
              }, {
                activator: _withCtx(({ props: menuProps }) => [
                  _createVNode(_component_v_tooltip, {
                    location: "bottom",
                    "open-delay": "250",
                    "open-on-hover": true
                  }, {
                    activator: _withCtx(({ props: tooltipProps }) => [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_v_btn, _mergeProps(_ctx.mergeProps(menuProps, tooltipProps), {
                          icon: "",
                          variant: "text",
                          style: {"padding":"8"}
                        }), {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                                _createTextVNode("mdi-menu", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 16)
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("message.selectedScenario")), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_subheader, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("message.selectedScenario")), 1)
                        ]),
                        _: 1
                      }),
                      (_ctx.getModel && _ctx.getModel.roles.includes('Calculator'))
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 0,
                            onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.calculateScenario(_ctx.getScenario);}),
                            disabled: _ctx.getScenario == null || (_ctx.getScenario.status > 0 && _ctx.getScenario.status < 9)
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_action, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                                      _createTextVNode("mdi-play-outline", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", null, [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("message.calculateScenario")), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }, 8, ["disabled"]))
                        : _createCommentVNode("", true),
                      (_ctx.getModel && _ctx.getModel.roles.includes('Editor'))
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 1,
                            disabled: _ctx.getScenario.parentScenarioId == null,
                            onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.editScenario({ id: _ctx.getScenario.id, name: _ctx.getScenario.name, competition: _ctx.getScenario.competition, isTop: _ctx.getScenario.isTop, parentScenarioId: _ctx.getScenario.parentScenarioId, changeCount: _ctx.getScenario.changeCount });})
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_action, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                                      _createTextVNode("mdi-pencil-outline", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", null, [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("message.editScenario")), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }, 8, ["disabled"]))
                        : _createCommentVNode("", true),
                      (_ctx.getModel && _ctx.getModel.roles.includes('Editor'))
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 2,
                            onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.confirmRemoveScenario(_ctx.getScenario);}),
                            disabled: _ctx.getScenario.parentScenarioId == null || _ctx.scenarioHasChildren
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_action, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                                      _createTextVNode("mdi-delete-outline", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", null, [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("message.removeScenario")), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }, 8, ["disabled"]))
                        : _createCommentVNode("", true),
                      (_ctx.getModel && _ctx.getModel.roles.includes('Calculator'))
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 3,
                            onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.fetchScenarioProcessingLog(_ctx.getScenario);})
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_action, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                                      _createTextVNode("mdi-view-list-outline", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", null, [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("message.scenarioProcessingLog")), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.getModel && _ctx.getModel.roles.includes('Editor'))
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 4,
                            onClick: _cache[9] || (_cache[9] = ($event: any) => {_ctx.mergeScenarioLocal(); _ctx.scenariosMenuVisible = false}),
                            disabled: _ctx.scenarioHasChildren
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_action, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [...(_cache[59] || (_cache[59] = [
                                      _createTextVNode("mdi-merge", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", null, [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("message.copyChanges")), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }, 8, ["disabled"]))
                        : _createCommentVNode("", true),
                      (_ctx.getModel && _ctx.getModel.roles.includes('Editor'))
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 5,
                            onClick: _cache[10] || (_cache[10] = ($event: any) => {_ctx.cloneScenarioLocal(); _ctx.scenariosMenuVisible = false}),
                            disabled: _ctx.getScenario.parentScenarioId == null
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_action, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                                      _createTextVNode("mdi-content-copy", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", null, [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("message.cloneScenario")), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }, 8, ["disabled"]))
                        : _createCommentVNode("", true),
                      (_ctx.getModel && _ctx.getModel.roles && _ctx.getModel.roles.includes('BulkUpload'))
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 6,
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openBulkUploadLocations()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_action, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                                      _createTextVNode("mdi-file-upload-outline", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", null, [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("message.uploadLocationsCsv")), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        (_ctx.scenario.status != 10)
          ? (_openBlock(), _createBlock(_component_v_progress_linear, {
              key: 0,
              "model-value": Math.round(100 / 8 * (_ctx.scenario.status - 1)),
              "buffer-value": Math.round(100 / 8 * (_ctx.scenario.status - 1)),
              indeterminate: _ctx.scenario.status > 0 && _ctx.scenario.status < 9,
              color: "#81C784",
              "bg-color": "#E8F5E9",
              "bg-opacity": 1,
              "buffer-color": "#4CAF50",
              "buffer-opacity": 0.5
            }, null, 8, ["model-value", "buffer-value", "indeterminate"]))
          : _createCommentVNode("", true),
        (_ctx.scenario.status >= 10)
          ? (_openBlock(), _createBlock(_component_v_progress_linear, {
              key: 1,
              "model-value": 100,
              color: "#E53935"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_v_menu, {
            "close-on-click": true,
            "max-height": "none",
            "close-on-content-click": false,
            class: "tbdc-floatingmenu",
            "content-class": "tbdc-floatingmenucontent",
            modelValue: _ctx.filterMenuVisible,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.filterMenuVisible) = $event))
          }, {
            activator: _withCtx(({ props: menuProps }) => [
              _createVNode(_component_v_tooltip, {
                location: "bottom",
                "open-delay": "250",
                "open-on-hover": true
              }, {
                activator: _withCtx(({ props: tooltipProps }) => [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_v_btn, {
                      icon: "",
                      variant: "text"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_v_icon, _normalizeProps(_guardReactiveProps(_ctx.mergeProps(menuProps, tooltipProps))), {
                            default: _withCtx(() => [...(_cache[62] || (_cache[62] = [
                              _createTextVNode("mdi-map-marker-outline", -1)
                            ]))]),
                            _: 1
                          }, 16)
                        ])
                      ]),
                      _: 2
                    }, 1024),
                    (_ctx.getFilterLocations!= null && _ctx.getFilterLocations != '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[63] || (_cache[63] = [
                          _createElementVNode("div", { style: {"text-align":"center"} }, " ! ", -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("message.filterAndSearch")), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_subheader, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("message.locationsType" + _ctx.getModel.locationsType + "FilterLocations")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_form, {
                    onSubmit: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["prevent"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_component_v_text_field, {
                              class: "text-field-icon",
                              density: "compact",
                              variant: "outlined",
                              modelValue: _ctx.standByFilterLocations,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.standByFilterLocations) = $event)),
                              "append-icon": _ctx.getFilterLocations!= null && _ctx.getFilterLocations != '' ? 'mdi-exclamation' : '',
                              "hide-details": "",
                              "single-line": "",
                              label: _ctx.$t('message.name'),
                              "onClick:clear": _cache[13] || (_cache[13] = ($event: any) => (_ctx.setFilterLocations(''))),
                              clearable: ""
                            }, null, 8, ["modelValue", "append-icon", "label"])
                          ]),
                          _createVNode(_component_v_list_item_action, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                type: "submit",
                                onClick: _cache[14] || (_cache[14] = ($event: any) => {_ctx.setFilterLocations(_ctx.standByFilterLocations);}),
                                icon: "",
                                variant: "text"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [...(_cache[64] || (_cache[64] = [
                                      _createTextVNode("mdi-filter-outline", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.getLocations != null && _ctx.getFilteredLocations != null)
                    ? (_openBlock(), _createBlock(_component_v_virtual_scroll, {
                        key: 0,
                        bench: "20",
                        height: Math.min(384,_ctx.getFilteredLocations.length * 48),
                        "min-width": Math.max(_ctx.maxLengthLocationName?.length*8,400),
                        "item-height": "48",
                        items: _ctx.getFilteredLocations
                      }, {
                        default: _withCtx(({ item }) => [
                          _createVNode(_component_v_list_item, {
                            onClick: ($event: any) => {item['zoomTo'] = true; _ctx.setLocation(item); _ctx.filterMenuVisible = false}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_action, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [...(_cache[65] || (_cache[65] = [
                                      _createTextVNode("mdi-map-marker-outline", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  (item.changeType == 1)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: require('../../assets/opening.png'),
                                        class: "tbdc-listitemoverlayimage"
                                      }, null, 8, _hoisted_13))
                                    : _createCommentVNode("", true),
                                  (item.changeType == 2)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 1,
                                        src: require('../../assets/closure.png'),
                                        class: "tbdc-listitemoverlayimage"
                                      }, null, 8, _hoisted_14))
                                    : _createCommentVNode("", true),
                                  (item.changeType == 3)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 2,
                                        src: require('../../assets/edit.png'),
                                        class: "tbdc-listitemoverlayimage"
                                      }, null, 8, _hoisted_15))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("div", null, [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1),
                                    (_ctx.getModel.locationGroups.length > 1)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, " (" + _toDisplayString(item.locationGroup) + ")", 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 1
                      }, 8, ["height", "min-width", "items"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_v_divider, {
            class: "tbdc-floatingmenudivider",
            vertical: ""
          }),
          _createVNode(_component_v_menu, {
            "close-on-click": true,
            "close-on-content-click": false,
            "content-class": "tbdc-floatingmenucontent"
          }, {
            activator: _withCtx(({ props: menuProps }) => [
              _createVNode(_component_v_tooltip, {
                location: "bottom",
                "open-delay": "250",
                "open-on-hover": true
              }, {
                activator: _withCtx(({ props: tooltipProps }) => [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_v_btn, _mergeProps({
                      icon: "",
                      variant: "text"
                    }, _ctx.mergeProps(menuProps, tooltipProps), {
                      density: "comfortable",
                      size: "default"
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[66] || (_cache[66] = [
                            _createTextVNode("mdi-layers-outline", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 16)
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("message.map")), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_subheader, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("message.scenarios")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_list_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_v_checkbox, {
                          density: "compact",
                          "hide-details": "",
                          class: "ml-2",
                          label: _ctx.$t("message.scenarioLocationsVisibleOnMap"),
                          value: true,
                          modelValue: _ctx.scenarioLocationsVisible,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.scenarioLocationsVisible) = $event)),
                          disabled: _ctx.getScenarioLocations == null || _ctx.getScenarioLocations.length == 0
                        }, null, 8, ["label", "modelValue", "disabled"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_list_subheader, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("message.layers")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_list_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_v_checkbox, {
                          density: "compact",
                          "hide-details": "",
                          class: "ml-2 mb-4",
                          label: _ctx.$t("message.satelliteView"),
                          modelValue: _ctx.satelliteView,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.satelliteView) = $event))
                        }, null, 8, ["label", "modelValue"]),
                        _createVNode(_component_v_checkbox, {
                          density: "compact",
                          "hide-details": "",
                          class: "ml-2 mb-4",
                          label: _ctx.$t("message.showLocationOutput"),
                          modelValue: _ctx.showLocationOutput,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.showLocationOutput) = $event))
                        }, null, 8, ["label", "modelValue"]),
                        _createVNode(_component_v_radio_group, {
                          modelValue: _ctx.areaSetVisible,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.areaSetVisible) = $event)),
                          class: "ml-2 mt-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t("message.dontShow"),
                              value: 0
                            }, null, 8, ["label"]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getModel.areaSets, (areaSet) => {
                              return (_openBlock(), _createBlock(_component_v_radio, {
                                key: areaSet.id,
                                label: areaSet.title == null?areaSet.name:areaSet.title,
                                value: areaSet.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  (_ctx.getModel.heatMapSets && _ctx.getModel.heatMapSets.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createVNode(_component_v_list_subheader, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("message.heatMaps")), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_list_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_21, [
                              (_ctx.getModel.allowMultipleHeatMapSets == true)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.getModel.heatMapSets, (heatMapSet) => {
                                    return (_openBlock(), _createBlock(_component_v_checkbox, {
                                      key: heatMapSet.id,
                                      density: "compact",
                                      "hide-details": "",
                                      class: "ml-2",
                                      label: heatMapSet.title == null?heatMapSet.name:heatMapSet.title,
                                      value: heatMapSet.id,
                                      modelValue: _ctx.heatMapSetsVisible,
                                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.heatMapSetsVisible) = $event))
                                    }, null, 8, ["label", "value", "modelValue"]))
                                  }), 128))
                                : _createCommentVNode("", true),
                              (_ctx.getModel.allowMultipleHeatMapSets == false)
                                ? (_openBlock(), _createBlock(_component_v_radio_group, {
                                    key: 1,
                                    modelValue: _ctx.heatMapSetVisible,
                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.heatMapSetVisible) = $event)),
                                    class: "ml-2 mt-0"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_radio, {
                                        label: _ctx.$t("message.dontShow"),
                                        value: 0
                                      }, null, 8, ["label"]),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getModel.heatMapSets, (heatMapSet) => {
                                        return (_openBlock(), _createBlock(_component_v_radio, {
                                          key: heatMapSet.id,
                                          label: heatMapSet.title == null?heatMapSet.name:heatMapSet.title,
                                          value: heatMapSet.id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_divider)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.getModel.poiSets && _ctx.getModel.poiSets.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createVNode(_component_v_list_subheader, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("message.pois")), 1),
                            (_ctx.getModel.allowMultiplePOISets == true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                  _createVNode(_component_v_btn, {
                                    variant: "outlined",
                                    size: "small",
                                    onClick: _ctx.selectAllPoiSets,
                                    class: "tbdc-floatingmenusubheaderbutton"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("message.selectAll")), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]),
                                  _cache[67] || (_cache[67] = _createTextVNode("/", -1)),
                                  _createVNode(_component_v_btn, {
                                    variant: "outlined",
                                    size: "small",
                                    onClick: _ctx.selectNoPoiSets,
                                    class: "tbdc-floatingmenusubheaderbutton"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("message.selectNone")), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_list_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_24, [
                              _createVNode(_component_v_checkbox, {
                                density: "compact",
                                "hide-details": "",
                                class: "ml-2 mb-4",
                                label: _ctx.$t("message.locationPois"),
                                modelValue: _ctx.showLocationPois,
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.showLocationPois) = $event)),
                                indeterminate: _ctx.showLocationPoisIndeterminate
                              }, null, 8, ["label", "modelValue", "indeterminate"]),
                              (_ctx.getModel.allowMultiplePOISets == true)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.getModel.poiSets, (poiSet) => {
                                    return (_openBlock(), _createBlock(_component_v_checkbox, {
                                      key: poiSet.id,
                                      density: "compact",
                                      "hide-details": "",
                                      class: "ml-2",
                                      label: poiSet.title == null?poiSet.name:poiSet.title,
                                      value: poiSet.id,
                                      modelValue: _ctx.poiSetsVisible,
                                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.poiSetsVisible) = $event))
                                    }, null, 8, ["label", "value", "modelValue"]))
                                  }), 128))
                                : _createCommentVNode("", true),
                              (_ctx.getModel.allowMultiplePOISets == false)
                                ? (_openBlock(), _createBlock(_component_v_radio_group, {
                                    key: 1,
                                    modelValue: _ctx.poiSetVisible,
                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.poiSetVisible) = $event)),
                                    class: "ml-2 mt-0"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_radio, {
                                        label: _ctx.$t("message.dontShow"),
                                        value: 0
                                      }, null, 8, ["label"]),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getModel.poiSets, (poiSet) => {
                                        return (_openBlock(), _createBlock(_component_v_radio, {
                                          key: poiSet.id,
                                          label: poiSet.title == null?poiSet.name:poiSet.title,
                                          value: poiSet.id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_divider)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_list_subheader, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("message.catchmentArea")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_list_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        (_ctx.getModel.catchmentAreaMode == 0)
                          ? (_openBlock(), _createBlock(_component_v_radio_group, {
                              key: 0,
                              modelValue: _ctx.catchmentArea,
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.catchmentArea) = $event)),
                              class: "ml-2 mt-0",
                              disabled: _ctx.getScenario.status != 9
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_radio, {
                                  label: _ctx.$t('message.all'),
                                  value: { coverage: 1,catchmentAreaId: _ctx.getModel.catchmentAreas[0].id, title: _ctx.getModel.catchmentAreas[0].title, areaSetId: _ctx.getModel.catchmentAreas[0].areaSetId, isoLineSetId: _ctx.getModel.catchmentAreas[0].isoLineSetId }
                                }, null, 8, ["label", "value"]),
                                _createVNode(_component_v_radio, {
                                  label: _ctx.$t('message.secondary'),
                                  value: { coverage: 0.8,catchmentAreaId: _ctx.getModel.catchmentAreas[0].id, title: _ctx.getModel.catchmentAreas[0].title, areaSetId: _ctx.getModel.catchmentAreas[0].areaSetId, isoLineSetId: _ctx.getModel.catchmentAreas[0].isoLineSetId }
                                }, null, 8, ["label", "value"]),
                                _createVNode(_component_v_radio, {
                                  label: _ctx.$t('message.primary'),
                                  value: { coverage: 0.5,catchmentAreaId: _ctx.getModel.catchmentAreas[0].id, title: _ctx.getModel.catchmentAreas[0].title, areaSetId: _ctx.getModel.catchmentAreas[0].areaSetId, isoLineSetId: _ctx.getModel.catchmentAreas[0].isoLineSetId }
                                }, null, 8, ["label", "value"]),
                                _createVNode(_component_v_radio, {
                                  label: _ctx.$t('message.none'),
                                  value: { coverage: 0 ,catchmentAreaId: _ctx.getModel.catchmentAreas[0].id,title: _ctx.getModel.catchmentAreas[0].title,  areaSetId: _ctx.getModel.catchmentAreas[0].areaSetId, isoLineSetId: _ctx.getModel.catchmentAreas[0].isoLineSetId }
                                }, null, 8, ["label", "value"])
                              ]),
                              _: 1
                            }, 8, ["modelValue", "disabled"]))
                          : _createCommentVNode("", true),
                        (_ctx.getModel.catchmentAreaMode == 1)
                          ? (_openBlock(), _createBlock(_component_v_radio_group, {
                              key: 1,
                              modelValue: _ctx.catchmentArea,
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.catchmentArea) = $event)),
                              class: "ml-2 mt-0",
                              disabled: _ctx.getScenario.status != 9
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getModel.catchmentAreasOnMap, (c) => {
                                  return (_openBlock(), _createBlock(_component_v_radio, {
                                    key: c.id,
                                    label: c.title,
                                    value: { coverage: 1.0, catchmentAreaId: c.id,title: c.title, areaSetId: c.areaSetId, isoLineSetId: c.isoLineSetId }
                                  }, null, 8, ["label", "value"]))
                                }), 128)),
                                _createVNode(_component_v_radio, {
                                  label: _ctx.$t('message.none'),
                                  value: null
                                }, null, 8, ["label"])
                              ]),
                              _: 1
                            }, 8, ["modelValue", "disabled"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_list_subheader, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("message.travelTimes")), 1)
                    ]),
                    _: 1
                  }),
                  (_ctx.getModel.isoLineSets.length == 1)
                    ? (_openBlock(), _createBlock(_component_v_list_subheader, { key: 2 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.getModel.isoLineSets[0].title), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_list_item, {
                    disabled: _ctx.getLocation == null
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        (_ctx.getModel.isoLineSets.length > 1)
                          ? (_openBlock(), _createBlock(_component_v_radio_group, {
                              key: 0,
                              modelValue: _ctx.isoLineSet,
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.isoLineSet) = $event)),
                              class: "ml-2 mt-0"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getModel.isoLineSets, (i) => {
                                  return (_openBlock(), _createBlock(_component_v_radio, {
                                    key: i.name,
                                    label: i.title,
                                    value: i
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("p", null, [
                          (_ctx.isoLineSet)
                            ? (_openBlock(), _createBlock(_component_v_slider, {
                                key: 0,
                                class: "ml-3 mt-8",
                                modelValue: _ctx.isoLineMinutes,
                                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.isoLineMinutes) = $event)),
                                disabled: _ctx.getLocation == null,
                                max: _ctx.isoLineSet.maximumMinutes,
                                min: "0",
                                "thumb-label": "always",
                                "thumb-color": "primary",
                                "thumb-size": 18,
                                step: 1,
                                "hide-details": "",
                                style: {"margin-inline":"8px 20px"}
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('message.minutes')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue", "disabled", "max"]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider, {
            class: "tbdc-floatingmenudivider",
            vertical: ""
          }),
          _createVNode(_component_v_menu, {
            "close-on-click": true,
            "close-on-content-click": false,
            class: "tbdc-floatingmenu",
            "content-class": "tbdc-floatingmenucontent",
            modelValue: _ctx.searchMenuVisible,
            "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.searchMenuVisible) = $event))
          }, {
            activator: _withCtx(({ props: menuProps }) => [
              _createVNode(_component_v_tooltip, {
                location: "bottom",
                "open-delay": "250",
                "open-on-hover": true
              }, {
                activator: _withCtx(({ props: tooltipProps }) => [
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_v_btn, {
                      icon: "",
                      variant: "text"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, _normalizeProps(_guardReactiveProps(_ctx.mergeProps(menuProps, tooltipProps))), {
                          default: _withCtx(() => [...(_cache[68] || (_cache[68] = [
                            _createTextVNode("mdi-magnify", -1)
                          ]))]),
                          _: 1
                        }, 16)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("message.search")), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_subheader, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("message.searchMap")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_form, {
                    onSubmit: _cache[38] || (_cache[38] = _withModifiers(() => {}, ["prevent"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_component_v_text_field, {
                              density: "compact",
                              variant: "outlined",
                              modelValue: _ctx.addressLocal,
                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.addressLocal) = $event)),
                              "single-line": "",
                              label: _ctx.$t('message.addressOrCoordinates'),
                              hint: _ctx.$t('message.addressOrCoordinatesHint'),
                              "persistent-hint": "",
                              onKeydown: _cache[31] || (_cache[31] = _withKeys(_withModifiers(($event: any) => {_ctx.searchAddressOrCoordinate(_ctx.addressLocal); _ctx.searchMenuVisible = false}, ["prevent"]), ["enter"])),
                              "onClick:clear": _cache[32] || (_cache[32] = ($event: any) => (_ctx.addressLocal = '')),
                              clearable: ""
                            }, null, 8, ["modelValue", "label", "hint"])
                          ]),
                          _createVNode(_component_v_list_item_action, { class: "align-self-start mt-3" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                onClick: _cache[33] || (_cache[33] = ($event: any) => {_ctx.searchAddressOrCoordinate(_ctx.addressLocal); _ctx.searchMenuVisible = false}),
                                icon: "",
                                variant: "text"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [...(_cache[69] || (_cache[69] = [
                                      _createTextVNode("mdi-map-marker", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_list_item, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_component_v_text_field, {
                              density: "compact",
                              variant: "outlined",
                              modelValue: _ctx.searchLocal,
                              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.searchLocal) = $event)),
                              "single-line": "",
                              label: _ctx.$t('message.query'),
                              hint: _ctx.$t('message.queryHint'),
                              "persistent-hint": "",
                              onKeydown: _cache[35] || (_cache[35] = _withKeys(_withModifiers(($event: any) => (_ctx.searchByBoundingBox(_ctx.searchLocal)), ["prevent"]), ["enter"])),
                              "onClick:clear": _cache[36] || (_cache[36] = ($event: any) => {_ctx.searchLocal = ''; _ctx.searchByBoundingBox(_ctx.searchLocal)}),
                              clearable: ""
                            }, null, 8, ["modelValue", "label", "hint"])
                          ]),
                          _createVNode(_component_v_list_item_action, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                onClick: _cache[37] || (_cache[37] = ($event: any) => {_ctx.searchByBoundingBox(_ctx.searchLocal); _ctx.searchMenuVisible = false}),
                                icon: "",
                                variant: "text"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [...(_cache[70] || (_cache[70] = [
                                      _createTextVNode("mdi-magnify", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_v_divider, {
            class: "tbdc-floatingmenudivider",
            vertical: ""
          }),
          (_ctx.getModel.roles.includes('ChartViewer'))
            ? (_openBlock(), _createBlock(_component_v_menu, {
                key: 0,
                "close-on-click": true,
                "close-on-content-click": true,
                "content-class": "tbdc-floatingmenucontent"
              }, {
                activator: _withCtx(({ props: menuProps }) => [
                  _createVNode(_component_v_tooltip, {
                    location: "bottom",
                    "open-delay": "250",
                    "open-on-hover": true
                  }, {
                    activator: _withCtx(({ props: tooltipProps }) => [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_v_btn, _mergeProps({
                          icon: "",
                          variant: "text"
                        }, _ctx.mergeProps(menuProps, tooltipProps)), {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[71] || (_cache[71] = [
                                _createTextVNode("mdi-chart-box-outline", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 16)
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("message.graphics")), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_subheader, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("message.graphics")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_list_item, {
                        onClick: _ctx.showMatchingLocationsOutputChart,
                        disabled: _ctx.getLocation == null || _ctx.getMatchingLocations == null || _ctx.getScenario.status != 9 || _ctx.getLocation.visibility != 0
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_action, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[72] || (_cache[72] = [
                                  _createTextVNode("mdi-chart-bar", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", null, [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("message.matchingLocationsOutputChart")), 1)
                              ]),
                              _: 1
                            }),
                            (_ctx.getLocation == null)
                              ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$tc("message.locationNotSelected")), 1)
                                  ]),
                                  _: 1
                                }))
                              : (_ctx.getScenario.status != 9)
                                ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, { key: 1 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$tc("message.scenarioNotCalculated")), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"]),
                      _createVNode(_component_v_list_item, {
                        onClick: _ctx.showMatchingLocationsRadarChart,
                        disabled: _ctx.getLocation == null || _ctx.getMatchingLocations == null || _ctx.getScenario.status != 9 || _ctx.getLocation.visibility != 0
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_action, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[73] || (_cache[73] = [
                                  _createTextVNode("mdi-spider-web", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", null, [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("message.matchingLocationsSimilarityChart")), 1)
                              ]),
                              _: 1
                            }),
                            (_ctx.getLocation == null)
                              ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$tc("message.locationNotSelected")), 1)
                                  ]),
                                  _: 1
                                }))
                              : (_ctx.getScenario.status != 9)
                                ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, { key: 1 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$tc("message.scenarioNotCalculated")), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"]),
                      _createVNode(_component_v_list_item, {
                        onClick: _ctx.showDriversChart,
                        disabled: !_ctx.getModel.hasDriverFilters || _ctx.getLocation == null || _ctx.getScenario.status != 9 || _ctx.getLocation.visibility != 0
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_action, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[74] || (_cache[74] = [
                                  _createTextVNode("mdi-chart-gantt", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", null, [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("message.driversChart")), 1)
                              ]),
                              _: 1
                            }),
                            (_ctx.getLocation == null)
                              ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$tc("message.locationNotSelected")), 1)
                                  ]),
                                  _: 1
                                }))
                              : (_ctx.getScenario.status != 9)
                                ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, { key: 1 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$tc("message.scenarioNotCalculated")), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"]),
                      _createVNode(_component_v_list_item, {
                        onClick: _cache[40] || (_cache[40] = ($event: any) => {_ctx.showPropertiesChart; _ctx.showPropertiesChart(); }),
                        disabled: _ctx.getLocation == null || _ctx.getScenario.status != 9 || _ctx.getLocation.visibility != 0
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_action, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[75] || (_cache[75] = [
                                  _createTextVNode("mdi-chart-scatter-plot", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", null, [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("message.propertiesChart")), 1)
                              ]),
                              _: 1
                            }),
                            (_ctx.getLocation == null)
                              ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$tc("message.locationNotSelected")), 1)
                                  ]),
                                  _: 1
                                }))
                              : (_ctx.getScenario.status != 9)
                                ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, { key: 1 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$tc("message.scenarioNotCalculated")), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_divider, {
            class: "tbdc-floatingmenudivider",
            vertical: ""
          }),
          (_ctx.getModel.roles.includes('ReportViewer'))
            ? (_openBlock(), _createBlock(_component_v_menu, {
                key: 1,
                "close-on-click": true,
                "close-on-content-click": true,
                "content-class": "tbdc-floatingmenucontent"
              }, {
                activator: _withCtx(({ props: menuProps }) => [
                  _createVNode(_component_v_tooltip, {
                    location: "bottom",
                    "open-delay": "250",
                    "open-on-hover": true
                  }, {
                    activator: _withCtx(({ props: tooltipProps }) => [
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_v_btn, _mergeProps({
                          icon: "",
                          variant: "text"
                        }, _ctx.mergeProps(menuProps, tooltipProps), {
                          disabled: _ctx.getScenario.status != 9
                        }), {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[76] || (_cache[76] = [
                                _createTextVNode("mdi-file-document-outline", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 16, ["disabled"])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("message.reports")), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_subheader, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("message.reports")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_list_item, {
                        onClick: _ctx.showLocationReport,
                        disabled: !_ctx.getLocationCatchmentArea || _ctx.getScenario.status != 9 || _ctx.getLocation == null || _ctx.getLocation.visibility != 0
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_action, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[77] || (_cache[77] = [
                                  _createTextVNode("mdi-printer", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", null, [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$tc("message.locationsType" + _ctx.getModel.locationsType + "Name")) + " " + _toDisplayString(_ctx.$tc("message.report")), 1)
                              ]),
                              _: 1
                            }),
                            (_ctx.getLocation == null)
                              ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$tc("message.locationNotSelected")), 1)
                                  ]),
                                  _: 1
                                }))
                              : (_ctx.getLocationCatchmentArea == null)
                                ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, { key: 1 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$tc("message.catchmentAreaNotSelected")), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"]),
                      _createVNode(_component_v_list_item, {
                        onClick: _ctx.showScenarioReport,
                        disabled: _ctx.getScenario == null || _ctx.getScenario.status != 9 || _ctx.getScenario.parentScenarioId == null
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_action, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[78] || (_cache[78] = [
                                  _createTextVNode("mdi-printer", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", null, [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("message.scenarioReport")), 1)
                              ]),
                              _: 1
                            }),
                            (_ctx.getScenario == null)
                              ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$tc("message.scenarioNotSelected")), 1)
                                  ]),
                                  _: 1
                                }))
                              : (_ctx.getScenario.status != 9)
                                ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, { key: 1 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$tc("message.scenarioNotCalculated")), 1)
                                    ]),
                                    _: 1
                                  }))
                                : (_ctx.getScenario.parentScenarioId == null)
                                  ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, { key: 2 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$tc("message.scenarioNotSelected")), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_divider, {
            class: "tbdc-floatingmenudivider",
            vertical: ""
          }),
          (_ctx.getModel != null && _ctx.getSubModel != null && _ctx.getSubModel.functionCount > 0)
            ? (_openBlock(), _createBlock(_component_v_menu, {
                key: 2,
                "close-on-click": true,
                "close-on-content-click": true,
                "content-class": "tbdc-floatingmenucontent"
              }, {
                activator: _withCtx(({ props: menuProps }) => [
                  _createVNode(_component_v_tooltip, {
                    location: "bottom",
                    "open-delay": "250",
                    "open-on-hover": true
                  }, {
                    activator: _withCtx(({ props: tooltipProps }) => [
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_v_btn, _mergeProps({
                          icon: "",
                          variant: "text"
                        }, _ctx.mergeProps(menuProps, tooltipProps)), {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[79] || (_cache[79] = [
                                _createTextVNode("mdi-calculator", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 16)
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$tc("message.score",2)), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_subheader, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$tc("message.score",2)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_list_item, {
                        onClick: _ctx.showLocationScores,
                        disabled: !(_ctx.getLocation && _ctx.getModel != null && _ctx.getSubModel != null && _ctx.getSubModel.functionCount > 0)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_action, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[80] || (_cache[80] = [
                                  _createTextVNode("mdi-printer", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", null, [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$tc("message.locationType" + _ctx.getModel.locationsType + "Scores")), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"]),
                      _createVNode(_component_v_list_item, {
                        onClick: _ctx.showAreaScores,
                        disabled: !(_ctx.getArea && _ctx.getModel != null && _ctx.getSubModel != null && _ctx.getSubModel.functionCount > 0)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_action, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[81] || (_cache[81] = [
                                  _createTextVNode("mdi-printer", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", null, [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$tc("message.areaScores")), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_divider, {
            class: "tbdc-floatingmenudivider",
            vertical: ""
          }),
          (_ctx.getModel.roles.includes('Exporter'))
            ? (_openBlock(), _createBlock(_component_v_menu, {
                key: 3,
                "close-on-click": true,
                "close-on-content-click": false,
                "content-class": "tbdc-floatingmenucontent"
              }, {
                activator: _withCtx(({ props: menuProps }) => [
                  _createVNode(_component_v_tooltip, {
                    location: "bottom",
                    "open-delay": "250",
                    "open-on-hover": true
                  }, {
                    activator: _withCtx(({ props: tooltipProps }) => [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_v_btn, _mergeProps({
                          icon: "",
                          variant: "text"
                        }, _ctx.mergeProps(menuProps, tooltipProps)), {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[82] || (_cache[82] = [
                                _createTextVNode("mdi-export", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 16)
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("message.export")), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_subheader, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("message.export")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card, {
                        flat: "",
                        variant: "outlined",
                        class: "mx-3 mb-2 pa-3",
                        color: "grey lighten-4"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('message.exportFormat')), 1),
                          _createElementVNode("div", _hoisted_31, [
                            _createVNode(_component_v_btn_toggle, {
                              modelValue: _ctx.exportFormat,
                              "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.exportFormat) = $event)),
                              mandatory: "",
                              density: "compact",
                              color: "primary"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  value: "xlsx",
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('message.xlsx')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_btn, {
                                  value: "csv",
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('message.csv')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_v_select, {
                              density: "compact",
                              variant: "outlined",
                              "hide-details": "",
                              disabled: _ctx.exportFormat !== 'csv',
                              modelValue: _ctx.fileFormatCulture,
                              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.fileFormatCulture) = $event)),
                              items: _ctx.languages,
                              label: _ctx.$t('message.fileFormatCulture')
                            }, null, 8, ["disabled", "modelValue", "items", "label"])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_divider, { class: "mb-2" }),
                      _createVNode(_component_v_list_item, {
                        disabled: _ctx.getScenario == null,
                        onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.exportData({ baseUrl: '/api/models/scenarios/' + _ctx.getScenario.id + '/locations/export', baseName: _ctx.$t('message.scenarioLocations') + ' ' + _ctx.getModel.name + ' - ' + _ctx.getScenario.name })))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_action, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[83] || (_cache[83] = [
                                  _createTextVNode("mdi-microsoft-excel", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", null, [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('message.sourceLocations')), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      (_ctx.getModel && _ctx.getModel.roles && _ctx.getModel.roles.includes('Owner'))
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 0,
                            disabled: _ctx.getScenario == null,
                            onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.exportData({ baseUrl: '/api/models/' + _ctx.getModel.id + '/scenarios/locations/export', baseName: _ctx.$t('message.scenarioLocationsAllScenarios') + ' ' + _ctx.getModel.name })))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_action, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [...(_cache[84] || (_cache[84] = [
                                      _createTextVNode("mdi-microsoft-excel", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", null, [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('message.sourceLocationsAllScenarios')) + " ", 1),
                                    _createVNode(_component_v_icon, {
                                      size: "x-small",
                                      color: "grey",
                                      title: _ctx.$t('message.ownerOnly')
                                    }, {
                                      default: _withCtx(() => [...(_cache[85] || (_cache[85] = [
                                        _createTextVNode("mdi-lock-outline", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["title"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }, 8, ["disabled"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_list_item, {
                        disabled: _ctx.getScenario == null || _ctx.getScenario.status != 9,
                        onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.exportData({ baseUrl: '/api/models/scenarios/' + _ctx.getScenario.id + '/output/export', baseName: _ctx.$t('message.scenarioLocationsOutput') + ' ' + _ctx.getModel.name + ' - ' + _ctx.getScenario.name })))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_action, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[86] || (_cache[86] = [
                                  _createTextVNode("mdi-microsoft-excel", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", null, [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('message.scenarioLocationsOutputDescription')), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_component_v_list_item, {
                        onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.exportData({ baseUrl: '/api/models/' + _ctx.getModel.id + '/output/export', baseName: _ctx.$t('message.modelScenarioLocationsOutput') + ' ' + _ctx.getModel.name })))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_action, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[87] || (_cache[87] = [
                                  _createTextVNode("mdi-microsoft-excel", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", null, [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('message.modelScenarioLocationsOutputDescription')), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }),
                      (_ctx.getModel && _ctx.getModel.roles && _ctx.getModel.roles.includes('Owner'))
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 1,
                            disabled: _ctx.getScenario == null || _ctx.getScenario.status != 9,
                            onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.exportData({ baseUrl: '/api/models/scenarios/' + _ctx.getScenario.id + '/output/export?includeHidden=true', baseName: _ctx.$t('message.scenarioLocationsOutput') + ' ' + _ctx.getModel.name + ' - ' + _ctx.getScenario.name })))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_action, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [...(_cache[88] || (_cache[88] = [
                                      _createTextVNode("mdi-microsoft-excel", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", null, [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('message.scenarioLocationsOutputDescriptionWithHidden')) + " ", 1),
                                    _createVNode(_component_v_icon, {
                                      size: "x-small",
                                      color: "grey",
                                      title: _ctx.$t('message.ownerOnly')
                                    }, {
                                      default: _withCtx(() => [...(_cache[89] || (_cache[89] = [
                                        _createTextVNode("mdi-lock-outline", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["title"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }, 8, ["disabled"]))
                        : _createCommentVNode("", true),
                      (_ctx.getModel.catchmentAreaMode == 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createVNode(_component_v_list_item, {
                              disabled: _ctx.getArea == null || _ctx.getScenario == null || _ctx.getScenario.status != 9,
                              onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.exportData({ baseUrl: '/api/models/' + _ctx.getSubModel.id + '/scenarios/' + _ctx.getScenario.id + '/areas/' + _ctx.getArea.areaCode + '/export/', baseName: _ctx.$t('message.areaInformationExport') + ' ' + _ctx.getModel.name + ' - ' + _ctx.getScenario.name + ' - '  + _ctx.getArea.areaCode })))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_action, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => [...(_cache[90] || (_cache[90] = [
                                        _createTextVNode("mdi-microsoft-excel", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createElementVNode("div", null, [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("message.areaInformationExportDescription")), 1)
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            }, 8, ["disabled"]),
                            _createVNode(_component_v_list_item, {
                              disabled: _ctx.getLocation == null|| _ctx.getScenario == null || _ctx.getScenario.status != 9 || _ctx.getLocation.visibility > 0,
                              onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.exportData({ baseUrl: '/api/models/' + _ctx.getSubModel.id + '/scenarios/' + _ctx.getScenario.id + '/locations/' + _ctx.getLocation.id + '/catchment-area/export', baseName: _ctx.$t('message.catchmentAreaInformationExport') + ' ' + _ctx.getModel.name + ' - ' + _ctx.getScenario.name + ' - ' + _ctx.getLocation.name })))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_action, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => [...(_cache[91] || (_cache[91] = [
                                        _createTextVNode("mdi-microsoft-excel", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createElementVNode("div", null, [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("message.catchmentAreaInformationExport")), 1)
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ], 64))
                        : _createCommentVNode("", true),
                      (_ctx.getModel.catchmentAreaMode == 1)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.getModel.catchmentAreasOnMap, (c) => {
                            return (_openBlock(), _createBlock(_component_v_list_item, {
                              key: '1-' + c.name + 'catchmentAreaInformationExport',
                              disabled: _ctx.getLocation == null || _ctx.getScenario == null || _ctx.getScenario.status != 9 || _ctx.getLocation.visibility > 0,
                              onClick: ($event: any) => (_ctx.exportData({ baseUrl: '/api/models/' + _ctx.getSubModel.id + '/scenarios/' + _ctx.getScenario.id + '/locations/' + _ctx.getLocation.id + '/catchment-area/export/' +  c.name, baseName: _ctx.$t('message.catchmentAreaInformationExport') + ' ' + _ctx.getModel.name + ' - ' + _ctx.getScenario.name + ' - ' + _ctx.getLocation.name }))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_action, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => [...(_cache[92] || (_cache[92] = [
                                        _createTextVNode("mdi-microsoft-excel", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createElementVNode("div", null, [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("message.catchmentAreaInformationExport")) + " (" + _toDisplayString(c.title) + ") ", 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["disabled", "onClick"]))
                          }), 128))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getModel.catchmentAreas, (c) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          key: '1-' + c.name + 'locationAreas',
                          disabled: _ctx.getLocation == null || _ctx.getLocation.visibility > 0,
                          onClick: ($event: any) => (_ctx.exportData({ baseUrl: '/api/models/scenarios/locations/' + _ctx.getLocation.id + '/areas/export/' + c.name, baseName: _ctx.$t('message.locationAreas') + ' ' +  _ctx.getLocation.name + ' - ' + c.name }))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_action, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [...(_cache[93] || (_cache[93] = [
                                    _createTextVNode("mdi-microsoft-excel", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", null, [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("message.locationAreas")) + " (" + _toDisplayString(c.title) + ") ", 1)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"]))
                      }), 128)),
                      (_ctx.getModel && _ctx.getModel.roles && _ctx.getModel.roles.includes('Owner'))
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 4,
                            onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.openExportAreasDialog()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_action, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [...(_cache[94] || (_cache[94] = [
                                      _createTextVNode("mdi-microsoft-excel", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", null, [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("message.exportAreas")) + " ", 1),
                                    _createVNode(_component_v_icon, {
                                      size: "x-small",
                                      color: "grey",
                                      title: _ctx.$t('message.ownerOnly')
                                    }, {
                                      default: _withCtx(() => [...(_cache[95] || (_cache[95] = [
                                        _createTextVNode("mdi-lock-outline", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["title"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_divider, { class: "my-2" }),
                      (_ctx.getModel && _ctx.getModel.roles && _ctx.getModel.roles.includes('Owner'))
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 5,
                            disabled: _ctx.getScenario == null || !_ctx.getModel.hasCalculationModel || _ctx.getLocation == null || _ctx.getLocation.visibility > 0,
                            onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.downloadFile({ url: '/api/models/scenarios/' + _ctx.getScenario.id + '/locations/' +  _ctx.getLocation.id + '/calculation-model',  name: _ctx.$t('message.calculationModel') + ' ' + _ctx.getModel.name + ' - ' + _ctx.getScenario.name + ' - ' + _ctx.getLocation.name  + '.xlsx' })))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_action, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [...(_cache[96] || (_cache[96] = [
                                      _createTextVNode("mdi-microsoft-excel", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", null, [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('message.calculationModel')) + " ", 1),
                                    _createVNode(_component_v_icon, {
                                      size: "x-small",
                                      color: "grey",
                                      title: _ctx.$t('message.ownerOnly')
                                    }, {
                                      default: _withCtx(() => [...(_cache[97] || (_cache[97] = [
                                        _createTextVNode("mdi-lock-outline", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["title"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }, 8, ["disabled"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_list_item, {
                        disabled: _ctx.getScenario == null,
                        onClick: _cache[52] || (_cache[52] = ($event: any) => {_ctx.$emit('exportMap');})
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_action, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[98] || (_cache[98] = [
                                  _createTextVNode("mdi-map", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", null, [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('message.exportMapToPng')), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.getModel && _ctx.getModel.roles && _ctx.getModel.roles.includes('Owner'))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createVNode(_component_v_divider, {
                  class: "tbdc-floatingmenudivider",
                  vertical: ""
                }),
                _createVNode(_component_v_menu, {
                  "close-on-click": true,
                  "close-on-content-click": false,
                  "content-class": "tbdc-floatingmenucontent"
                }, {
                  activator: _withCtx(({ props: menuProps }) => [
                    _createVNode(_component_v_tooltip, {
                      location: "bottom",
                      "open-delay": "250",
                      "open-on-hover": true
                    }, {
                      activator: _withCtx(({ props: tooltipProps }) => [
                        _createElementVNode("div", _hoisted_32, [
                          _createVNode(_component_v_btn, _mergeProps({
                            icon: "",
                            variant: "text"
                          }, _ctx.mergeProps(menuProps, tooltipProps), {
                            disabled: _ctx.getLocation == null
                          }), {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[99] || (_cache[99] = [
                                  _createTextVNode("mdi-vector-polygon", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 16, ["disabled"]),
                          _createVNode(_component_v_icon, {
                            size: "10",
                            style: {"position":"absolute","right":"6px","bottom":"7px","opacity":"0.55","pointer-events":"none"}
                          }, {
                            default: _withCtx(() => [...(_cache[100] || (_cache[100] = [
                              _createTextVNode("mdi-lock-outline", -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("message.isoLine")) + " (" + _toDisplayString(_ctx.$t("message.ownerOnly")) + ")", 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getIsoLineParameters, (isoLineParameter) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: isoLineParameter.url
                      }, [
                        _createVNode(_component_v_list, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_subheader, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(isoLineParameter.profile), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_list_item, {
                              disabled: _ctx.getLocation == null
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createVNode(_component_v_text_field, {
                                    "append-icon": "mdi-help-circle-outline",
                                    label: "Parameters",
                                    variant: "outlined",
                                    density: "compact",
                                    modelValue: isoLineParameter.parameters,
                                    "onUpdate:modelValue": ($event: any) => ((isoLineParameter.parameters) = $event),
                                    "onClick:append": ($event: any) => (_ctx.showIsoLineHelp(isoLineParameter))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick:append"]),
                                  _createVNode(_component_v_text_field, {
                                    label: "Post processing actions",
                                    variant: "outlined",
                                    density: "compact",
                                    modelValue: isoLineParameter.postProcessingActions,
                                    "onUpdate:modelValue": ($event: any) => ((isoLineParameter.postProcessingActions) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                  _cache[101] || (_cache[101] = _createElementVNode("code", null, "[{\"Iterations\":2,\"Type\":\"IsoLineSmootheningAction\"},{\"Distance\":0.0025,\"Type\":\"IsoLineBufferAction\"}]", -1)),
                                  _createVNode(_component_v_slider, {
                                    density: "compact",
                                    label: "Minutes",
                                    min: 1,
                                    max: isoLineParameter.maximumMinutes,
                                    step: 1,
                                    modelValue: isoLineParameter.minutes,
                                    "onUpdate:modelValue": ($event: any) => ((isoLineParameter.minutes) = $event)
                                  }, {
                                    append: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(isoLineParameter.minutes), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["max", "modelValue", "onUpdate:modelValue"]),
                                  _createElementVNode("div", _hoisted_33, [
                                    _createVNode(_component_v_btn, {
                                      color: "primary",
                                      density: "compact",
                                      onClick: ($event: any) => (_ctx.fetchIsoLine({ profile:  isoLineParameter.profile,minutes: isoLineParameter.minutes, isoLineSetId:  isoLineParameter.isoLineSetId,  baseUrl: isoLineParameter.baseUrl,parameters: isoLineParameter.parameters,postProcessingActions: isoLineParameter.postProcessingActions}))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("message.fetchIsoLine")), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ])
                                ])
                              ]),
                              _: 2
                            }, 1032, ["disabled"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_divider)
                      ], 64))
                    }), 128))
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.getModel && _ctx.getModel.roles && _ctx.getModel.roles.includes('Agent'))
            ? (_openBlock(), _createBlock(_component_v_divider, {
                key: 5,
                class: "tbdc-floatingmenudivider",
                vertical: ""
              }))
            : _createCommentVNode("", true),
          (_ctx.getModel && _ctx.getModel.roles && _ctx.getModel.roles.includes('Agent'))
            ? (_openBlock(), _createBlock(_component_Agent, {
                key: 6,
                agentMessage: _ctx.getAgentMessage,
                agentMessages: _ctx.getAgentMessages,
                areaFilter: _ctx.getArea,
                locationFilter: _ctx.getFilterLocationIds
              }, null, 8, ["agentMessage", "agentMessages", "areaFilter", "locationFilter"]))
            : _createCommentVNode("", true)
        ])
      ], 64))
    : _createCommentVNode("", true)
}